module.exports = __webpack_public_path__ + "static/media/item8.28d47e7f.jpg";